// extracted by mini-css-extract-plugin
export default {"titleBlock":"Title_titleBlock__llUHr","title":"Title_title__xs1SK","titleMask":"Title_titleMask__bvx+n"};